import styled from 'styled-components'
import { Col } from 'atomic/legacy/obj.grid'

export const PlaceholderColStyled = styled(Col)`
  text-align: center;
`
